import React, { useCallback, useContext, useEffect, useState, useRef } from "react";
import { MenuItem } from "@mui/material";
import { IconButton } from "@mui/material";

import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { SquarePen } from "lucide-react";
import Button from "../../../../componentsv2/Button";
import Paper from "../../../../componentsv2/Paper";
import { useSnackbar } from "notistack";

import DataPickerAtualizado from "../../../../components/DataPickerAtualizado";
import GridContainer from "../../../../componentsv2/GridContainer";
import GridItem from "../../../../componentsv2/GridItem";
import { Input } from "../../../../componentsv2/Input";
import SelectEnfermeiro from "../../Components/SelectEnfermeiro";
import TabelaProcedimentos from "./Components/TabelaProcedimentos";
import SelectSituacao from "../../Components/SelectSituacao";
import SelectHorariosDisponiveis from "../../Components/SelectHorariosDisponiveis";
import AutoCompleteClientes from "../../../../componentsv2/AutoCompleteClientes";
import { api } from "../../../../services/Api";
import ModalProcedimento from "../ModalProcedimento";
import useSelectClientes from "../../data/hooks/useSelectClientes";
import SelectEstado from "../../../../componentsv2/SelectEstado";
import SelectFormaPagamento from "../../Components/SelectFormaPagamento";
import { Context } from "../../../../Context/PermissoesContext";
import Header from "../../../../components/Header";
import Container from "../../../../componentsv2/Container";
import AutoCompleteMedicos from "../../../../componentsv2/AutoCompleteMedicos/Index";
import {
  OPCOES_LOCAL_ATENDIMENTO,
  OPCOES_MEDICACAO_ORIGEM,
  OPCOES_PAGAMENTO_STATUS,
} from "../../constants/agendamentoOptions";
import { abrirNoMaps, temEnderecoMinimo } from "../../utils/abrirNoMaps";
import { formatarMetadadosEvolucao } from "../../utils/evolucaoFormatters";

export default function FormularioAgendamento() {
  const { enqueueSnackbar } = useSnackbar();
  const [openModalForm, setOpenModalForm] = useState(false);
  const history = useHistory();
  const { checarPermissao } = useContext(Context);
  const [procedimentoSelecionado, setProcedimentoSelecionado] = useState([]);

  const { cliente, setCliente, medico, setMedico } = useSelectClientes();
  const [enfermeiroId, setEnfermeiroId] = useState("");
  const [data, setData] = useState(new Date());
  const [hora, setHora] = useState("");
  const [situacao, setSituacao] = useState("");
  const [endereco, setEndereco] = useState("");
  const [numeroEndereco, setNumeroEndereco] = useState("");
  const [cep, setCep] = useState("");
  const [bairro, setBairro] = useState("");
  const [cidade, setCidade] = useState("");
  const [complemento, setComplemento] = useState("");
  const [observacao, setObservacao] = useState("");
  const [estado, setEstado] = useState("");
  const [totalExames, setTotalExames] = useState(0);
  const [desconto, setDesconto] = useState(0);
  const [formaPagamento, setFormaPagamento] = useState("");
  const [localAtendimento, setLocalAtendimento] = useState("");
  const [medicacaoOrigem, setMedicacaoOrigem] = useState("");
  const [pagamentoStatus, setPagamentoStatus] = useState("");
  const [arquivosPrescricao, setArquivosPrescricao] = useState([]);
  const [evolucoes, setEvolucoes] = useState([]);
  const [novaEvolucao, setNovaEvolucao] = useState("");
  const [evolucaoEmEdicaoId, setEvolucaoEmEdicaoId] = useState(null);
  const [textoEvolucaoEdicao, setTextoEvolucaoEdicao] = useState("");

  const [kilometragem, setKilometragem] = useState("");

  const [atualizaTabelaProcedimentos, setAtualizaTabelaProcedimentos] =
    useState(false);

  const debounceTimerRef = useRef(null);
  const inputPrescricoesRef = useRef(null);
  const usuarioLogado = localStorage.getItem("@DNACenter:codigoUsuario");

  const atualizarTabelaProcedimentos = () => {
    setAtualizaTabelaProcedimentos(!atualizaTabelaProcedimentos);
  };

  const criarEvolucao = () => {
    const descricao = novaEvolucao.trim();
    if (!descricao) {
      enqueueSnackbar("Informe a evolução antes de salvar.", {
        variant: "warning",
      });
      return;
    }

    setEvolucoes((prevState) => [
      {
        id: `${Date.now()}-${prevState.length}`,
        descricao,
        criadoEm: new Date().toISOString(),
      },
      ...prevState,
    ]);
    setNovaEvolucao("");
  };

  const iniciarEdicaoEvolucao = (evolucao) => {
    setEvolucaoEmEdicaoId(evolucao.id);
    setTextoEvolucaoEdicao(evolucao.descricao || "");
  };

  const cancelarEdicaoEvolucao = () => {
    setEvolucaoEmEdicaoId(null);
    setTextoEvolucaoEdicao("");
  };

  const salvarEdicaoEvolucao = (evolucaoId) => {
    const descricao = textoEvolucaoEdicao.trim();
    if (!descricao) {
      enqueueSnackbar("Informe a evolução antes de salvar.", {
        variant: "warning",
      });
      return;
    }

    setEvolucoes((prevState) =>
      prevState.map((evolucao) =>
        evolucao.id === evolucaoId ? { ...evolucao, descricao } : evolucao
      )
    );
    cancelarEdicaoEvolucao();
  };

  const excluirEvolucao = (evolucaoId) => {
    setEvolucoes((prevState) => prevState.filter((evolucao) => evolucao.id !== evolucaoId));
    if (evolucaoEmEdicaoId === evolucaoId) {
      cancelarEdicaoEvolucao();
    }
  };

  const buscarDadosCliente = useCallback(async () => {
    if (!cliente?.id) {
      return;
    }

    try {
      const {
        data: { data },
      } = await api.get(`v2/controleDna/cliente/${cliente.id}`);
      setBairro(data.bairro);
      setEndereco(data.endereco);
      setNumeroEndereco(data.enderecoNumero);
      setCep(data.cep);
      setCidade(data.cidade);
      setEstado(data.estado);
    } catch (error) {
      enqueueSnackbar(error.response.data.messages, {
        variant: "error",
      });
    }
  }, [cliente, enqueueSnackbar]);

  const pesquisarKilometragem = useCallback(
    async (enderecoPesquisa) => {
      try {
        const { data: enderecosEncontrados = [] } = await api.get(
          "/v2/agendaCare/pesquisaEndereco",
          {
            params: {
              endereco: enderecoPesquisa,
            },
          }
        );

        if (enderecosEncontrados.length === 0) {
          setKilometragem("");
          return;
        }

        const enderecoSelecionado = enderecosEncontrados[0]?.formatted_address;
        if (!enderecoSelecionado) {
          setKilometragem("");
          return;
        }

        const { data } = await api.post("/v2/agendaCare/distancia", {
          destino: [enderecoSelecionado],
        });

        if (!data?.[0]?.distance?.text) {
          setKilometragem("");
          return;
        }

        setKilometragem(data[0].distance.text);
      } catch (error) {
        setKilometragem("");
        enqueueSnackbar(error.response.data.messages, {
          variant: "error",
          autoHideDuration: 4000,
        });
      }
    },
    [enqueueSnackbar]
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    const refButton = document.getElementById("agendarButton");
    refButton.disabled = true;
    let agendamentoId = null;

    const mostrarErroUpload = (error) => {
      const status = error?.response?.status;
      if (status === 413) {
        enqueueSnackbar(
          error?.response?.data?.messages ||
            "Limite excedido: até 10MB por arquivo e no máximo 20 arquivos por envio.",
          {
          variant: "warning",
          }
        );
        return;
      }
      if (status === 415) {
        enqueueSnackbar(error?.response?.data?.messages || "Formato inválido. Envie PDF, JPG ou PNG.", {
          variant: "warning",
        });
        return;
      }
      if (status === 404) {
        enqueueSnackbar(
          error?.response?.data?.messages || "Agendamento não encontrado para anexar prescrição.",
          {
          variant: "error",
          }
        );
        return;
      }
      enqueueSnackbar(error?.response?.data?.messages || "Erro ao enviar prescrições.", {
        variant: "error",
      });
    };

    try {
      const possuiValor = (value) => Boolean(String(value ?? "").trim());

      const camposObrigatorios = [
        { label: "Cliente", value: cliente?.id },
        { label: "Médico", value: medico?.id },
        { label: "Enfermeiro", value: enfermeiroId },
        { label: "Data", value: data },
        { label: "Situação", value: situacao },
        { label: "Horário", value: hora },
        { label: "Endereço", value: endereco },
        { label: "Número", value: numeroEndereco },
        { label: "CEP", value: cep },
        { label: "Bairro", value: bairro },
        { label: "Cidade", value: cidade },
        { label: "Local", value: localAtendimento },
        { label: "Medicação", value: medicacaoOrigem },
        { label: "Pagamento", value: pagamentoStatus },
      ];
      const campoFaltante = camposObrigatorios.find(
        ({ value }) => !possuiValor(value)
      );
      if (campoFaltante) {
        enqueueSnackbar(`Preencha o campo obrigatório: ${campoFaltante.label}.`, {
          variant: "warning",
        });
        return;
      }

      const procedimentosId = procedimentoSelecionado.map(
        (procedimento) => procedimento.id
      );
      if (procedimentosId.length === 0) {
        enqueueSnackbar("Selecione ao menos um procedimento.", {
          variant: "warning",
        });
        return;
      }
      // Normaliza data localmente para evitar inconsistência de estado no submit.
      const dataNormalizada = data.hasOwnProperty("$d")
        ? data.$d.setHours(0, 0, 0)
        : data.setHours(0, 0, 0);

      // console.log("dataSetada", dataSetada);
      const dados = {
        procedimentosId,
        enfermeiroId,
        data: dataNormalizada,
        hora,
        complemento,
        observacoes: observacao,
        situacao,
        estado,
        cep,
        cidade,
        bairro,
        enderecoNumero: numeroEndereco,
        endereco,
        clienteId: cliente.id,
        desconto: desconto ? desconto : 0,
        formaPagamento,
        localAtendimento,
        medicacaoOrigem,
        pagamentoStatus,
        distancia: kilometragem,
        medicoId: medico.id,
      };
      const respostaCriacao = await api.post("/v2/agendaCare/agendamento", dados);
      agendamentoId =
        respostaCriacao?.data?.data?.id ||
        respostaCriacao?.data?.id ||
        respostaCriacao?.data?.dataValues?.id;

      if (!agendamentoId) {
        throw new Error("ID do agendamento não retornado.");
      }

      if (evolucoes.length > 0) {
        try {
          await Promise.all(
            evolucoes.map((evolucao) =>
              api.post(`/v2/agendaCare/agendamento/${agendamentoId}/evolucoes`, {
                descricao: evolucao.descricao,
              })
            )
          );
        } catch (error) {
          enqueueSnackbar(error.response.data.messages, { variant: "warning" });
        }
      }

      if (arquivosPrescricao.length > 0) {
        const formData = new FormData();
        arquivosPrescricao.forEach((arquivoPrescricao) => {
          formData.append("file", arquivoPrescricao);
        });

        await api.post(`/v2/agendaCare/agendamento/${agendamentoId}/prescricoes`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      history.push("/agendaCare");
      enqueueSnackbar("Agendamento feito com sucesso!", {
        variant: "success",
      });
    } catch (error) {
      const status = error?.response?.status;
      const erroDeUpload = [413, 415, 404].includes(status);

      if (erroDeUpload && agendamentoId) {
        enqueueSnackbar(error?.response?.data?.messages, { variant: "warning" });
        history.push("/agendaCare");
        return;
      }

      enqueueSnackbar(error?.response?.data?.messages, { variant: "error" });
    } finally {
      refButton.disabled = false;
    }
  };

  useEffect(() => {
    buscarDadosCliente();
  }, [buscarDadosCliente]);

  useEffect(() => {
    if (procedimentoSelecionado.length === 0) {
      setTotalExames(0);
      return;
    }

    const arrayDePrecos = procedimentoSelecionado?.map(
      (procedimento) => procedimento.precoExame
    );
    let result = arrayDePrecos?.reduce((a, b) => {
      return a + b;
    });
    result = result - desconto;
    const resultado = result.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    });
    setTotalExames(resultado);
  }, [procedimentoSelecionado, desconto]);

  useEffect(() => {
    const enderecoPesquisa = [
      endereco?.trim(),
      numeroEndereco?.trim(),
      bairro?.trim(),
      cidade?.trim(),
      estado?.trim(),
    ]
      .filter(Boolean)
      .join(", ");

    if (enderecoPesquisa.length === 0) {
      setKilometragem("");
      return;
    }

    if (enderecoPesquisa.length < 3) {
      return;
    }

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    debounceTimerRef.current = setTimeout(() => {
      pesquisarKilometragem(enderecoPesquisa);
    }, 500);

    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, [endereco, numeroEndereco, bairro, cidade, estado, pesquisarKilometragem]);

  return (
    <>
      <Header titulo={"Formulário de Agendamento"} />
      <Container>
        <Button onClick={() => history.push({ pathname: "/agendaCare" })}>
          <ArrowBackIcon style={{ color: "#003399" }} />
        </Button>
        <Paper
          style={{
            padding: "1rem",
            alignItems: "center",
            display: "flex",
            justfyContent: "center",
            marginTop: "10px",
          }}
          elevation={2}
        >
          {openModalForm && (
            <ModalProcedimento
              open={openModalForm}
              onClose={() => {
                setOpenModalForm(false);
                atualizarTabelaProcedimentos();
              }}
            />
          )}
          <form onSubmit={handleSubmit}>
            <GridContainer sx={{ margin: "1px" }} spacing={2} xs={12}>
              <GridContainer item sm={6} xs={12} spacing={2}>
                <GridItem xs={12}>
                  <AutoCompleteClientes
                    value={cliente}
                    onChange={setCliente}
                    required
                  />
                </GridItem>
                <GridItem xs={12}>
                  <AutoCompleteMedicos
                    onChange={setMedico}
                    value={medico}
                    required
                  />
                </GridItem>

                <GridItem xs={6}>
                  <DataPickerAtualizado
                    required
                    variant="standard"
                    labelName="Data"
                    xs={3}
                    data={data}
                    setData={setData}
                  />
                </GridItem>
                <GridItem xs={6}>
                  <SelectSituacao
                    onChange={(e) => {
                      setSituacao(e.target.value);
                    }}
                    value={situacao}
                    todas={false}
                    required
                  />
                </GridItem>

                <GridItem xs={6}>
                  <SelectEnfermeiro
                    onChange={(e) => {
                      setEnfermeiroId(e.target.value);
                      setHora("");
                    }}
                    value={enfermeiroId}
                    required
                  />
                </GridItem>

                <GridItem xs={6}>
                  <SelectHorariosDisponiveis
                    onChange={(e) => {
                      setHora(e.target.value);
                    }}
                    data={data}
                    value={hora}
                    enfermeiroId={enfermeiroId}
                    required
                  />
                </GridItem>

                <GridItem xs={8}>
                  <Input
                    required
                    fullWidth
                    onChange={(e) => {
                      setEndereco(e.target.value);
                    }}
                    value={endereco}
                    label="Endereço"
                    type="text"
                    variant="standard"
                  />
                </GridItem>
                <GridItem xs={4}>
                  <Input
                    onChange={(e) => {
                      setNumeroEndereco(e.target.value);
                    }}
                    value={numeroEndereco}
                    required
                    fullWidth
                    label="Número"
                    type="text"
                    variant="standard"
                  ></Input>
                </GridItem>
                <GridItem xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    type="button"
                    size="small"
                    variant="text"
                    disabled={!temEnderecoMinimo({ endereco, cidade, cep })}
                    onClick={() =>
                      abrirNoMaps({
                        endereco,
                        numero: numeroEndereco,
                        bairro,
                        cidade,
                        estado,
                        cep,
                      })
                    }
                  >
                    Abrir no Maps
                  </Button>
                </GridItem>

                <GridItem xs={12}>
                  <Input
                    required
                    fullWidth
                    onChange={(e) => {
                      setCep(e.target.value);
                    }}
                    value={cep}
                    label="CEP"
                    type="text"
                    variant="standard"
                  />
                </GridItem>
                <GridItem xs={4}>
                  <Input
                    onChange={(e) => {
                      setBairro(e.target.value);
                    }}
                    value={bairro}
                    required
                    fullWidth
                    label="Bairro"
                    type="text"
                    variant="standard"
                  ></Input>
                </GridItem>

                <GridItem xs={4}>
                  <Input
                    onChange={(e) => {
                      setCidade(e.target.value);
                    }}
                    value={cidade}
                    required
                    fullWidth
                    label="Cidade"
                    type="text"
                    variant="standard"
                  ></Input>
                </GridItem>

                <GridItem xs={4}>
                  <SelectEstado
                    onChange={(e) => {
                      setEstado(e.target.value);
                    }}
                    value={estado}
                  />
                </GridItem>

                <GridItem xs={12}>
                  <Input
                    onChange={(e) => {
                      setComplemento(e.target.value);
                    }}
                    value={complemento}
                    fullWidth
                    label="Complemento"
                    type="text"
                    variant="standard"
                  ></Input>
                </GridItem>

                <GridItem xs={4}>
                  <Input
                    select
                    required
                    fullWidth
                    label="Local"
                    value={localAtendimento}
                    onChange={(e) => setLocalAtendimento(e.target.value)}
                    variant="standard"
                  >
                    {OPCOES_LOCAL_ATENDIMENTO.map((opcao) => (
                      <MenuItem key={opcao.value} value={opcao.value}>
                        {opcao.label}
                      </MenuItem>
                    ))}
                  </Input>
                </GridItem>
                <GridItem xs={4}>
                  <Input
                    select
                    required
                    fullWidth
                    label="Medicação"
                    value={medicacaoOrigem}
                    onChange={(e) => setMedicacaoOrigem(e.target.value)}
                    variant="standard"
                  >
                    {OPCOES_MEDICACAO_ORIGEM.map((opcao) => (
                      <MenuItem key={opcao.value} value={opcao.value}>
                        {opcao.label}
                      </MenuItem>
                    ))}
                  </Input>
                </GridItem>
                <GridItem xs={4}>
                  <Input
                    select
                    required
                    fullWidth
                    label="Pagamento"
                    value={pagamentoStatus}
                    onChange={(e) => setPagamentoStatus(e.target.value)}
                    variant="standard"
                  >
                    {OPCOES_PAGAMENTO_STATUS.map((opcao) => (
                      <MenuItem key={opcao.value} value={opcao.value}>
                        {opcao.label}
                      </MenuItem>
                    ))}
                  </Input>
                </GridItem>
                <GridItem xs={12}>
                  <Input
                    onChange={(e) => {
                      setObservacao(e.target.value);
                    }}
                    value={observacao}
                    multiline
                    maxRows={5}
                    fullWidth
                    label="Observações"
                    type="text"
                    variant="standard"
                  />
                </GridItem>

                <GridItem xs={12} style={{ marginTop: "12px" }}>
                  <h4 style={{ margin: "8px 0 12px 0" }}>Evolução do paciente</h4>
                  <div
                    style={{
                      border: "1px solid #E0E0E0",
                      borderRadius: "10px",
                      padding: "16px",
                      backgroundColor: "#FAFAFA",
                    }}
                  >
                    <Input
                      fullWidth
                      multiline
                      minRows={2}
                      maxRows={5}
                      label="Nova evolução"
                      value={novaEvolucao}
                      onChange={(event) => setNovaEvolucao(event.target.value)}
                      variant="outlined"
                    />
                    <div style={{ marginTop: "14px", display: "flex", justifyContent: "flex-end" }}>
                      <Button type="button" variant="contained" color="blue" onClick={criarEvolucao}>
                        Salvar evolução
                      </Button>
                    </div>
                  </div>

                  <div
                    style={{
                      marginTop: "10px",
                      height: "165px",
                      overflowY: "auto",
                      paddingRight: "6px",
                    }}
                  >
                    {evolucoes.map((evolucao) => {
                      const emEdicao = evolucaoEmEdicaoId === evolucao.id;
                      const metadados = formatarMetadadosEvolucao(evolucao, {
                        usuarioPadrao: usuarioLogado || "Usuario",
                      });
                      return (
                        <div
                          key={evolucao.id}
                          style={{
                            padding: "6px 0",
                            marginBottom: "4px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "4px",
                              gap: "8px",
                            }}
                          >
                            <div style={{ fontSize: "10px", color: "#616161", lineHeight: 1.2 }}>
                              <strong>{metadados.usuario}</strong> - {metadados.dataHora}
                            </div>
                            {!emEdicao && (
                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <IconButton
                                  onClick={() => iniciarEdicaoEvolucao(evolucao)}
                                  size="small"
                                >
                                  <SquarePen size={18} color="#003399" />
                                </IconButton>
                                <IconButton
                                  onClick={() => excluirEvolucao(evolucao.id)}
                                  size="small"
                                >
                                  <DeleteForeverIcon style={{ color: "#D32F2F", fontSize: "18px" }} />
                                </IconButton>
                              </div>
                            )}
                          </div>

                          {emEdicao ? (
                            <Input
                              fullWidth
                              multiline
                              minRows={2}
                              maxRows={5}
                              value={textoEvolucaoEdicao}
                              onChange={(event) => setTextoEvolucaoEdicao(event.target.value)}
                              variant="outlined"
                            />
                          ) : (
                            <div
                              style={{
                                fontSize: "12px",
                                marginBottom: "4px",
                                lineHeight: 1.25,
                                whiteSpace: "pre-wrap",
                              }}
                            >
                              {evolucao.descricao}
                            </div>
                          )}

                          <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
                            {emEdicao ? (
                              <>
                                <Button
                                  type="button"
                                  variant="outlined"
                                  color="gray"
                                  onClick={cancelarEdicaoEvolucao}
                                >
                                  Cancelar
                                </Button>
                                <Button
                                  type="button"
                                  variant="contained"
                                  color="blue"
                                  onClick={() => salvarEdicaoEvolucao(evolucao.id)}
                                >
                                  Salvar
                                </Button>
                                <Button
                                  type="button"
                                  variant="text"
                                  color="red"
                                  onClick={() => excluirEvolucao(evolucao.id)}
                                >
                                  Remover
                                </Button>
                              </>
                            ) : null}
                          </div>
                        </div>
                      );
                    })}

                    {evolucoes.length === 0 && (
                      <span style={{ fontSize: "14px", color: "#666" }}>
                        Nenhuma evolução adicionada neste agendamento.
                      </span>
                    )}
                  </div>
                </GridItem>
              </GridContainer>

              <GridItem xs={12} sm={6}>
                <GridItem xs={12}>
                  <TabelaProcedimentos
                    atualizaTabela={atualizaTabelaProcedimentos}
                    setSelectedRows={setProcedimentoSelecionado}
                  />
                </GridItem>

                <GridContainer
                  spacing={1}
                  xs={12}
                  justifyContent="space-between"
                  sx={{ marginTop: "5px" }}
                >
                  <GridItem sm={4} xs={12}>
                    <SelectFormaPagamento
                      onChange={(e) => {
                        setFormaPagamento(e.target.value);
                      }}
                      value={formaPagamento}
                      required
                    />
                  </GridItem>
                  {checarPermissao("AGC002") && (
                    <>
                      <GridItem sm={4} xs={12}>
                        <Input
                          onChange={(e) => {
                            setDesconto(e.target.value);
                          }}
                          value={desconto}
                          fullWidth
                          label="Desconto R$:"
                          type="number"
                          variant="standard"
                        />
                      </GridItem>

                      <GridItem sm={4} xs={12}>
                        <Input
                          value={totalExames}
                          fullWidth
                          label="Total"
                          type="text"
                          inputProps={{ readOnly: true }}
                          variant="standard"
                        />
                      </GridItem>

                      <GridItem sm={4} xs={12}>
                        <Input
                          value={kilometragem}
                          fullWidth
                          label="Kilometragem"
                          type="text"
                          inputProps={{ readOnly: true }}
                          variant="standard"
                        />
                      </GridItem>
                    </>
                  )}
                </GridContainer>

                <GridContainer spacing={1} xs={12} sx={{ marginTop: "12px" }}>
                  <GridItem xs={12}>
                    <h4 style={{ margin: "8px 0" }}>Prescrições</h4>
                    <div
                      style={{
                        border: "1px dashed #B0BEC5",
                        borderRadius: "10px",
                        minHeight: "110px",
                        padding: "14px 16px",
                        backgroundColor: "#FAFAFA",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="file"
                        ref={inputPrescricoesRef}
                        multiple
                        accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
                        style={{ display: "none" }}
                        onChange={(event) => {
                          const arquivosSelecionados = Array.from(event.target.files || []);
                          setArquivosPrescricao(arquivosSelecionados);
                        }}
                      />
                      <Button
                        type="button"
                        variant="outlined"
                        style={{ color: "#0D47A1", fontSize: "16px", fontWeight: 600 }}
                        onClick={(event) => {
                          event.preventDefault();
                          inputPrescricoesRef.current?.click();
                        }}
                      >
                        Selecionar prescrições
                      </Button>
                      <span
                        style={{
                          marginTop: "14px",
                          fontSize: "14px",
                          color: "#424242",
                          fontWeight: 500,
                          textAlign: "center",
                        }}
                      >
                        PDF, JPG ou PNG - até 10MB por arquivo
                      </span>
                    </div>
                  </GridItem>
                  <GridItem xs={12}>
                    {arquivosPrescricao.length > 0 ? (
                      <div style={{ marginTop: "10px" }}>
                        {arquivosPrescricao.map((arquivo) => (
                          <div
                            key={`${arquivo.name}-${arquivo.size}`}
                            style={{
                              fontSize: "16px",
                              color: "#616161",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              marginBottom: "6px",
                            }}
                          >
                            <DescriptionOutlinedIcon style={{ fontSize: "20px" }} />
                            <span>{arquivo.name}</span>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <span style={{ fontSize: "14px", color: "#666", marginTop: "8px" }}>
                        Nenhum arquivo novo selecionado.
                      </span>
                    )}
                  </GridItem>
                </GridContainer>
              </GridItem>
            </GridContainer>
            <GridContainer
              item
              sx={{ marginTop: "30px" }}
              justifyContent="flex-end"
              spacing={2}
            >
              <GridItem>
                <Button
                  onClick={() => history.push({ pathname: "/agendaCare" })}
                  color="gray"
                  variant="outlined"
                >
                  Cancelar
                </Button>
              </GridItem>
              <GridItem>
                <Button
                  id="agendarButton"
                  type="submit"
                  color="blue"
                  variant="contained"
                >
                  Agendar
                </Button>
              </GridItem>
            </GridContainer>
          </form>
        </Paper>
      </Container>
    </>
  );
}
